<template>
    <div class="flex items-center gap-1 font-freizeit">
        <label class="flex flex-col items-center text-base leading-none">
            <span>
                {{ proofPlacement?.components[1].custom['oe-label'] }}
            </span>
            <span class="text-tiny font-freizeit-bold">
                {{ proofPlacement?.name }}
            </span>
        </label>

        <button
            type="button"
            role="switch"
            :aria-checked="isChecked"
            :aria-label="`Change proof to ${ unselectedProof }`"
            @click="toggleProof"
            class="relative inline-flex h-10 w-16 flex-shrink-0 rounded-full border border-dust p-px bg-cloud-dark"
        >
            <span
                aria-hidden="true"
                :class="[ isChecked ? 'translate-x-[24px]' : 'translate-x-0' ]"
                class="transform rounded-full border border-cloud-dark h-9 w-9 bg-shine transition duration-200 ease-in-out"
            ></span>
        </button>

        <label class="flex flex-col items-center text-base leading-none">
            <span>
                {{ proofPlacement?.components[2].custom['oe-label'] }}
            </span>
            <span class="text-tiny font-freizeit-bold">
                {{ proofPlacement?.name }}
            </span>
        </label>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        data() {
            return {
                unselectedProof: '114',
            };
        },

        computed: {
            isChecked() {
                return this.selectedProof?.code === 'Proof114';
            },

            selectedProof() {
                return this.customizerStore.viewController?.selectedAtPlacement('Proof');
            },

            proofPlacement() {
                return this.proofGroupData?.[0].placements[0];
            },

            proofGroupData() {
                return this.allGroups?.filter((group) => group.code === 'Proof');
            },

            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },
        },

        methods: {
            toggleProof() {
                this.setSelectedOption(`Proof${this.unselectedProof}`);

                this.unselectedProof = this.isChecked ? '90' : '114';
            },

            setSelectedOption(proofCode) {
                this.customizerStore.viewController.updateComponent('Proof', proofCode);

                this.updateBottleLabel();
            },

            updateBottleLabel() {
                this.customizerStore.setProofLabels();
                this.customizerStore.setAlcoholLabel();
            },
        },
    };
</script>
